import { render } from "./FlatMortgage.vue?vue&type=template&id=9e839182&scoped=true"
import script from "./FlatMortgage.vue?vue&type=script&lang=js"
export * from "./FlatMortgage.vue?vue&type=script&lang=js"

import "./FlatMortgage.vue?vue&type=style&index=0&id=9e839182&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e839182"]])

export default __exports__